import Axios from 'axios';
import { Config } from '../apiRoutes';
import { authHeaders } from '../headers';

import {
  CART_LAYOUTS_REQUESTED,
  CART_LAYOUTS_SUCCESS,
  CART_LAYOUTS_FAILURE,
  CART_LAYOUT_FIND_REQUESTED,
  CART_LAYOUT_FIND_SUCCESS,
  CART_LAYOUT_FIND_FAILURE,
  CART_LAYOUT_CREATE_REQUESTED,
  CART_LAYOUT_CREATE_SUCCESS,
  CART_LAYOUT_CREATE_FAILURE,
  CART_LAYOUT_UPDATE_REQUESTED,
  CART_LAYOUT_UPDATE_SUCCESS,
  CART_LAYOUT_UPDATE_FAILURE,
  CART_LAYOUT_DELETE_REQUESTED,
  CART_LAYOUT_DELETE_SUCCESS,
  CART_LAYOUT_DELETE_FAILURE,
} from '../types';

export const cartLayoutsRequested = () => {
  return {
    type: CART_LAYOUTS_REQUESTED
  }
};

export const cartLayoutsSuccess = (cartLayouts) => {
  return {
    type: CART_LAYOUTS_SUCCESS,
    payload: cartLayouts
  }
};

export const cartLayoutsFailure = () => {
  return {
    type: CART_LAYOUTS_FAILURE
  }
};

export const cartLayoutFindRequested = () => {
  return {
    type: CART_LAYOUT_FIND_REQUESTED
  }
};

export const cartLayoutFindSuccess = (cartLayout) => {
  return {
    type: CART_LAYOUT_FIND_SUCCESS,
    payload: cartLayout
  }
};

export const cartLayoutFindFailure = () => {
  return {
    type: CART_LAYOUT_FIND_FAILURE
  }
};

export const cartLayoutCreateRequested = () => {
  return {
    type: CART_LAYOUT_CREATE_REQUESTED
  }
};

export const cartLayoutCreateSuccess = (cartLayout) => {
  return {
    type: CART_LAYOUT_CREATE_SUCCESS,
    payload: cartLayout
  }
};

export const cartLayoutCreateFailure = () => {
  return {
    type: CART_LAYOUT_CREATE_FAILURE
  }
};



export const cartLayoutUpdateRequested = () => {
  return {
    type: CART_LAYOUT_UPDATE_REQUESTED
  }
};

export const cartLayoutUpdateSuccess = (cartLayout) => {
  return {
    type: CART_LAYOUT_UPDATE_SUCCESS,
    payload: cartLayout
  }
};

export const cartLayoutUpdateFailure = () => {
  return {
    type: CART_LAYOUT_UPDATE_FAILURE
  }
};


export const cartLayoutDisableRequested = (cartLayoutId) => {
  return {
    type: CART_LAYOUT_DELETE_REQUESTED,
    cartLayoutId: cartLayoutId
  }
};

export const cartLayoutDisableSuccess = () => {
  return {
    type: CART_LAYOUT_DELETE_SUCCESS
  }
};

export const cartLayoutDisableFailure = () => {
  return {
    type: CART_LAYOUT_DELETE_FAILURE
  }
};



export const cartLayoutsIndex = () => {
  return async (dispatch) => {
    dispatch(cartLayoutsRequested());

    const endPoint = Config.baseUrl + Config.cartLayouts;
    const headers = await authHeaders();

    return Axios.get(endPoint, { headers: headers })
      .then((response) => {
        dispatch(cartLayoutsSuccess(response.data));
      })
  }
}

export const cartLayoutFind = (cartLayoutId) => {
  return async (dispatch) => {
    dispatch(cartLayoutFindRequested());

    const endPoint = Config.baseUrl + Config.cartLayout + cartLayoutId;
    const headers = await authHeaders();

    return Axios.get(endPoint, { headers: headers })
      .then((response) => {
        dispatch(cartLayoutFindSuccess(response.data));
      })
      .catch(() => {
        dispatch(cartLayoutFindFailure());
      });

  }
}

export const cartLayoutCreate = (label, rows, columns, maxItemsPerTote) => {
  return async (dispatch) => {
    dispatch(cartLayoutCreateRequested());

    const endPoint = Config.baseUrl + Config.cartLayout;
    const headers = await authHeaders();

    return Axios.post(endPoint, { label: label, rows: rows, columns: columns, maxItemsPerTote: maxItemsPerTote }, { headers: headers })
      .then((response) => {
        dispatch(cartLayoutCreateSuccess(response.data));
      })
      .catch(() => {
        dispatch(cartLayoutCreateFailure());
      });

  }
}

export const cartLayoutUpdate = (id, label, rows, columns, maxItemsPerTote) => {
  return async (dispatch) => {
    dispatch(cartLayoutUpdateRequested());

    const endPoint = Config.baseUrl + Config.cartLayout;
    const headers = await authHeaders();

    return Axios.put(endPoint, { id: id, label: label, rows: rows, columns: columns, maxItemsPerTote: maxItemsPerTote }, { headers: headers })
      .then((response) => {
        dispatch(cartLayoutUpdateSuccess(response.data));
      })

  }
}

export const cartLayoutDisable = (id) => {
  return async (dispatch) => {
    dispatch(cartLayoutDisableRequested(id));

    const endPoint = Config.baseUrl + Config.cartLayout + id;
    const headers = await authHeaders();

    return Axios.delete(endPoint, { headers: headers })
      .then((response) => {
        dispatch(cartLayoutDisableSuccess(response.data));
      })
      .catch(() => {
        dispatch(cartLayoutDisableFailure());
      });
  }
}
